import { CRISIS_HELPLINES, CRISIS_NOTICE } from '@tarot/shared';

/**
 * 위기 발화 안내 — 타로 해석 대신 상담 창구를 먼저 보여준다.
 *
 * 문구·번호는 shared safety.ts 단일 출처. 여기서 새로 쓰지 않는다.
 * 전화번호는 `tel:` 링크로 — 모바일에서 한 번에 걸리는 게 이 화면의 목적이다.
 *
 * `compact`는 입력창 바로 아래에 붙는 축약형(제목 없이 창구만).
 */
export function CrisisNotice({ compact, footer }: { compact?: boolean; footer?: boolean }) {
  return (
    <section
      role="alert"
      className="flex flex-col gap-3 rounded-3xl border border-gold/30 bg-gold/5 p-5"
    >
      {!compact && (
        <>
          <h3 className="text-center text-base font-semibold text-moon">{CRISIS_NOTICE.title}</h3>
          <p className="text-center text-sm leading-relaxed text-moon">{CRISIS_NOTICE.body}</p>
        </>
      )}
      {compact && (
        <p className="text-sm leading-relaxed text-moon">
          혼자 견디지 않으셔도 돼요. 지금 바로 이야기 나눌 수 있어요.
        </p>
      )}
      <ul className="flex flex-col gap-2">
        {CRISIS_HELPLINES.map((h) => (
          <li key={h.tel}>
            <a
              href={`tel:${h.tel}`}
              className="flex items-baseline justify-between gap-3 rounded-xl border border-white/15 bg-night-2 px-3 py-2.5 transition hover:border-gold/60"
            >
              <span className="flex flex-col">
                <span className="text-sm font-medium text-moon">{h.name}</span>
                <span className="text-[11px] text-moon-dim/70">{h.note}</span>
              </span>
              <span className="shrink-0 text-base font-bold tabular-nums text-gold">{h.tel}</span>
            </a>
          </li>
        ))}
      </ul>
      {footer && <p className="text-xs leading-relaxed text-moon-dim/70">{CRISIS_NOTICE.footer}</p>}
    </section>
  );
}
